import React from 'react';
import { CandidateCheckbox } from './candidate-checkbox';
import { HourSelector } from './hour-selector';
import { CourseSelector } from './course-selector';
import { CandidateName } from './candidate-name';

export const CandidateRow = ({ student }) => {
    const center = { verticalAlign: 'middle' };
    return (
        <tr>
            <td style={center}><CandidateCheckbox student={student} /></td>
            <td style={center}><HourSelector student={student} /></td>
            <td style={center}><CandidateName student={student}/></td>
            <td style={center}><CourseSelector  student={student} /></td>
        </tr>
    );
};
